module.exports = __webpack_public_path__ + "static/img/smartControlCore1.114f2553.png";